  export default function markExtents(state, type) {
    const { doc, selection } = state;
    let $pos = doc.resolve(selection.from),
      parent = $pos.parent;
    let start = parent.childAfter($pos.parentOffset);
    // The selection start isn't set.
    if (!start.node) return null;

    let mark = start.node.marks.find(mark => mark.type === type);
    // The selection start doesn't contain the mark.
    if (!mark) return null;

    // Walk the mark extents forward.
    let endIndex = $pos.index(),
      endPos = $pos.start() + start.offset;
    while (endIndex < parent.childCount && mark.isInSet(parent.child(endIndex).marks))
      endPos += parent.child(endIndex++).nodeSize;
    // The selection goes beyond the mark extents.
    if (selection.to > endPos) return null;

    // Walk the mark extents backwards.
    let startIndex = $pos.index(),
      startPos = $pos.start() + start.offset;
    while (startIndex > 0 && mark.isInSet(parent.child(startIndex - 1).marks))
      startPos -= parent.child(--startIndex).nodeSize;
    // The selection is contained in the mark extents.
    return { from: startPos, to: endPos, mark };
  }